module.exports = __webpack_public_path__ + "img/dafiti-app.245fbb89.png";